import React from 'react';
import { Rate } from 'antd';

import './styles.scss';
import 'antComponentsStyle';

const TrafficLights = ({ className, onClick, selected, enabled }) => {
    return <span className={`prescoring-traffic-lights ${className}`}>
        <LightItem
            selected={selected && selected.length ? selected.some(selectedItem => selectedItem === 2) : false}
            onClick={onClick ? () => onClick(2) : null}
            disabled={typeof onClick !== 'function'}
            visible={enabled && enabled.length ? enabled.some(enabledItem => enabledItem === 2) : true}
        />
        <LightItem
            selected={selected && selected.length ? selected.some(selectedItem => selectedItem === 1) : false}
            onClick={onClick ? () => onClick(1) : null}
            disabled={typeof onClick !== 'function'}
            visible={enabled && enabled.length ? enabled.some(enabledItem => enabledItem === 1) : true}
        />
        <LightItem
            selected={selected && selected.length ? selected.some(selectedItem => selectedItem === 0) : false}
            onClick={onClick ? () => onClick(0) : null}
            disabled={typeof onClick !== 'function'}
            visible={enabled && enabled.length ? enabled.some(enabledItem => enabledItem === 0) : true}
        />
    </span>
}

const LightItem = ({ selected, onClick, disabled, visible }) => <Rate
  character="●"
  count={1}
  className={`item ${!visible && 'hidden'}`}
  value={selected === true ? 1 : null}
  onChange={onClick}
  disabled={disabled}
/>

export default TrafficLights;
